'use client';
import { useEffect, useState } from 'react';
import { useAccount } from 'wagmi';
import WalletWrapper from './WalletWrapper';

export default function LoginButton() {
  const { address, isConnected } = useAccount();
  const [profile, setProfile] = useState<{
    username: string;
    avatar_url: string;
  } | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (isConnected && address) {
        try {
          const response = await fetch(`/api/profile?address=${address}`);
          if (response.ok) {
            const data = await response.json();
            setProfile(data);
          }
        } catch (error) {
          console.error('Error fetching profile:', error);
        }
      }
    };

    fetchProfile();
  }, [isConnected, address]);

  return (
    <WalletWrapper
      className="min-w-[90px] bg-lightblue text-bg-white hover:bg-dark-blue"
      text="Log in"
      withWalletAggregator={true}
      profileName={profile?.username}
      profileAvatar={profile?.avatar_url}
    />
  );
}
